module.exports = __webpack_public_path__ + "img/Susan.d51fca37.png";